import { Card, Col, Row } from 'antd'
import React from 'react'

const IndigoFlightContents = () => {
    return (
        <div className='container'>
            <Row gutter={20}>
                <Col md={24}>
                    <Card className='mb-5'>
                        <h2 className='mb-3'>Book Indigo Airlines Flights at the Best Prices</h2>
                        <p className='mb-2'>Indigo Airlines is the largest and most renowned low-cost airline in India, known for its affordability, extensive domestic and international presence, and high service standards. Irrespective of whether you are travelling for a business trip or a leisure one, Indigo is the perfect choice for you as they are recognised for punctual flights, clean aircraft, and efficient services.</p>
                        <p className='mb-2'>With SuperbWorldTrip, booking Indigo Airlines flights is a breeze. Our platform guarantees the lowest fares on Indigo flights, convenient booking tools and instant confirmation. Enhance your Indigo flight booking experience with round-the-clock customer support services from SuperbWorldTrip.</p>
                        <p className='mb-4'>Enjoy exclusive deals on Indigo Airlines ticket booking only at SuperbWorldTrip!</p>
                        <hr />

                        <h2 className='mb-3 mt-4'>Why Choose Indigo Airlines?</h2>
                        <ul className='mb-4'>
                            <li><b>Punctual and Reliable</b> - The Indigo flights consistently score above average on-time performance, making them one of the most reliable and efficient carriers in India.</li>
                            <li><b>Budget-Friendly</b> - The fares charged for Indigo air ticket booking are extremely affordable, a perfect way to fly for cost-conscious travellers.</li>
                            <li><b>Wide Network</b> - Indigo serves 90+ cities in the country and 30+ cities internationally.</li>
                            <li><b>Excellent Safety</b> - Award-winning service and state-of-the-art safety standards.</li>
                            <li><b>Accolades</b> - Indigo is recognised globally as Asia’s leading low-cost carrier.</li>
                            <li><b>Ease of Operations</b> - Indigo Airlines online booking is straightforward, making it accessible to all types of clientele.</li>
                        </ul>
                        <hr />

                        <h2 className='mb-3 mt-4'>Indigo Airlines Fleet & Connectivity</h2>
                        <ul className='mb-4'>
                            <li><b>Aircraft Types</b> - Airbus A320-200, A320neo, A321neo, and ATR 72-600 aircraft are used for passenger operations.</li>
                            <li><b>Fleet Size</b> - There are more than 350 aircraft in active use.</li>
                            <li><b>Domestic Reach</b> - Indigo has a vast network, connecting major metro cities and emerging tier-2/tier-3 cities across India.</li>
                            <li><b>International Presence</b> - The airline is also growing internationally with regular flights to the UAE, Singapore, Thailand, Malaysia, Vietnam, Qatar, and so on.</li>
                            <li><b>Operations Scale</b> - 2,000+ daily flights across the country and international destinations, making air travel for cost-conscious travellers easy and flexible.</li>
                        </ul>
                        <hr />

                        <h2 className='mb-3 mt-4'>Popular Indigo Flight Routes</h2>
                        <h3 className='mb-2'>Domestic Routes</h3>
                        <table className='mb-3'>
                            <thead>
                                <tr>
                                    <th>Route</th>
                                    <th>Avg. Duration</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr><td>Delhi to Mumbai</td><td>2 hours</td></tr>
                                <tr><td>Bangalore to Hyderabad</td><td>1 hour 15 minutes</td></tr>
                                <tr><td>Mumbai to Chennai</td><td>2 hours</td></tr>
                                <tr><td>Delhi to Bengaluru</td><td>2 hours 45 minutes</td></tr>
                                <tr><td>Kolkata to Guwahati</td><td>1 hour 15 minutes</td></tr>
                                <tr><td>Jaipur to Delhi</td><td>1 hour</td></tr>
                            </tbody>
                        </table>

                        <h3 className='mb-2'>International Routes</h3>
                        <p className='mb-2'>Indigo flight booking has been growing exponentially, offering flights to some of the most popular international destinations. Popular international destinations include the following:</p>
                        <ul className='mb-3'>
                            <li>Delhi to Dubai</li>
                            <li>Mumbai to Singapore</li>
                            <li>Bangalore to Bangkok</li>
                            <li>Mumbai to Abu Dhabi</li>
                            <li>Delhi to Toronto</li>
                            <li>Bengaluru to Bangkok</li>
                        </ul>

                        <h3 className='mb-2'>Travel Tips</h3>
                        <ul className='mb-4'>
                            <li>Make sure your passport has a validity of six months from the date of travel.</li>
                            <li>Look up the visa and transit requirements of your destination and for any layover country.</li>
                            <li>For the best choice of seats and the opportunity of sitting with companions, seek to check in online early.</li>
                            <li>Check the latest weather report and prepare accordingly.</li>
                        </ul>
                        <p className='mb-4'>Indigo is rapidly expanding its global presence. Keep checking regularly for new international routes.</p>

                        <hr />

                        <h2 className='mb-3 mt-4'>How to Book Indigo Flights on SuperbWorldTrip</h2>
                        <p className='mb-2'>The experience of booking an Indigo flight with SuperbWorldTrip is quite simple and straightforward. You can follow these steps for an easy experience:</p>
                        <ul className='mb-4'>
                            <li>Visit the website - <a href="https://superbworldtrip.com/" target="_blank" rel="noopener noreferrer">https://superbworldtrip.com/</a></li>
                            <li>Select your source and destination cities.</li>
                            <li>Pick the preferred travel dates.</li>
                            <li>Apply the “Indigo airline” filter to only see the Indigo flight ticket booking options.</li>
                            <li>Browse through Indigo’s schedule and fares.</li>
                            <li>Select and confirm your flight.</li>
                            <li>Enter your details and make the payment.</li>
                            <li>Receive instant e-tickets.</li>
                        </ul>

                        <hr />

                        <h2 className='mb-3 mt-4'>Baggage Policy of Indigo Airlines</h2>
                        <h3>Cabin Baggage</h3>
                        <ul className='mb-3'>
                            <li>Allowance - 1 carry-on bag (max 7kg) + 1 personal item (laptop bag, purse, etc.)</li>
                            <li>Bag Dimension - Max 115cm (L+W+H)</li>
                            <li>Personal items - Laptop, handbag, camera bag.</li>
                        </ul>
                        <h3>Checked Baggage</h3>
                        <ul className='mb-3'>
                            <li>Domestic - 15kg standard.</li>
                            <li>International - 20 - 40kg (varies by route & travel class).</li>
                            <li>Infants - Infants travelling with Indigo are allowed one hand baggage up to 7kg (max 115cm) and a stroller or baby carriage free of charge. Checked baggage is not included for infant passengers.</li>
                            <li>Sports Equipment - Passengers are permitted to carry sports equipment; charges may apply based on size and weight.</li>
                        </ul>
                        <h3>Extra Baggage Charges</h3>
                        <ul className='mb-3'>
                            <li>Flyers can use discounted pre-booking extra baggage options. Different slabs are offered by the airline at 3kg, 5kg, 10kg, and more.</li>
                            <li>At the airport, it costs about ₹600 per extra kg.</li>
                        </ul>
                        <p className='mb-4'><b>Tip</b>: Always book extra luggage online while buying the tickets to avoid paying extra at the airport.</p>

                        <hr />

                        <h2 className='mb-3 mt-4'>Indigo Web Check-in & Verification Process</h2>
                        <p>For an Indigo ticket, the web check-in through the website and app is usually available 24-48 hours before departure.</p>
                        <p>The procedure of the check-in usually includes the following steps:</p>
                        <ul className='mb-3'>
                            <li>Log in to the website/app</li>
                            <li>Enter PNR</li>
                            <li>Select the preferred seat</li>
                            <li>Download the boarding pass.</li>
                        </ul>
                        <h4><b>Required Documents:</b></h4>
                        <ul className='mb-3'>
                            <li>For domestic travel, passengers can provide any one of the government-issued documents, from the Aadhaar Card, PAN Card, or Driving License.</li>
                            <li>For international travel, a Passport along with a valid visa is necessary.</li>
                        </ul>

                        <h3 className='mb-2'>Indigo Cancellation & Refund Policy</h3>
                        <p>Being one of the leading carriers in India, Indigo offers flexible changes and cancellations. The fees for changes/cancellations will vary depending on certain parameters set by the airline.</p>
                        <ul className='mb-3'>
                            <li><b>Cancellations</b> - Lower fees for changes more than 3 days before departure time. The cancellation charges become considerably higher (up to full ticket loss) if cancelled less than 3 days from the day of departure.</li>
                            <li><b>Refunds</b> - Processed to the original payment method, within 7 - 10 business days.</li>
                        </ul>
                        <p className='mb-3'>Cancellations can be completed via SuperbWorldTrip, Indigo’s website/app, or customer care.</p>

                        <h3>Why Book Indigo Flights with SuperbWorldTrip?</h3>
                        <ul className='mb-4'>
                            <li>Best deals guaranteed on Indigo flights with SuperbWorldTrip</li>
                            <li>Diverse payment options (UPI, Debit Cards, Credit Cards, Wallets)</li>
                            <li>24x7 customer service</li>
                            <li>Fast processing and simple booking management</li>
                            <li>E-ticket provided instantly</li>
                            <li>Promo codes, exclusive offers, and 100% cashback*</li>
                        </ul>

                        <hr />

                        <h2 className='mb-3 mt-4'>Frequently Asked Questions</h2>
                        <ol>
                            <li><b>Can I cancel my Indigo flight booking online?</b><br />Yes, you can easily cancel via SuperbWorldTrip or Indigo’s official website/app.</li>
                            <li><b>How much baggage can I carry?</b><br />For domestic travelling, the standard allowance is 7kg of cabin baggage + 15kg of checked baggage. Baggage allowance varies for international travel depending on the route and travel class.</li>
                            <li><b>How early should I check in?</b><br />Generally, the web check-in opens 48 hours prior to departure. If you are checking in at the airport, the recommended minimum time is 2 hours before the flight for domestic and 3 hours for international travel.</li>
                            <li><b>How do I change my Indigo ticket booking?</b><br />You can manage your booking by using the SuperbWorldTrip website or Indigo’s portal. You can easily reschedule or modify your flight.</li>
                            <li><b>Are infants allowed free baggage?</b><br />Indigo has an elaborate infant baggage policy. As an overview, infants travelling via Indigo are allowed 7kg of carry-on luggage in addition to the stroller or baby carrier.</li>
                        </ol>
                    </Card>
                </Col>
            </Row>
        </div>
    )
}

export default IndigoFlightContents